module.exports = __webpack_public_path__ + "img/006-time-is-money.d624fd0a.svg";